module.exports = __webpack_public_path__ + "static/img/meigui.fd6da27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/meigui.png
// module id = uEt6
// module chunks = 1